import { PREMIER, NON_PREMIER } from "./constants";

export function premierRuleFactory(isPremier) {
  return async function premierRule(node) {
    const { premierStatus } = node;

    if (!premierStatus) return true;

    return (
      (premierStatus === PREMIER && isPremier) ||
      (premierStatus === NON_PREMIER && !isPremier)
    );
  };
}
